<template>

<app-view-list-field :is-condensed="isCondensed" :is-sticky="isSticky" :field="field" :filter="filter">

    <span v-if="item.play.location">{{ item.play.location }}</span>
    <span v-if="!item.play.location">-</span>

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'item', 'filter', 'isCondensed', 'isSticky']

}

</script>

<style scoped>

</style>